import { openModal } from '@core/components/ModalStack';
import { FormShareModalProps } from './FormShareModal';

export async function openFormShareModal(props: FormShareModalProps) {
  const { FormShareModal } = await import('./FormShareModal');

  openModal(FormShareModal, props);
}
